import Vue from 'vue'

export const setVariantAttributes = (state, param) => {
  state.attributes = param
}

export const setProductIdVariant = (state, param) => {
  state.productId = param
}

export const setProductVariants = (state, param) => {
  state.result.lists = param.data.data.product_variant
  state.result.count = param.data.data.products_count
  state.result.page = param.data.data.page.number
  state.result.pricingModel = param.data.data.pricing_model
  state.result.productWeight = param.data.data.product_weight
}

export const setSearchVariant = (state, param) => {
  state.search = param
}

export const setSearchVariantPage = (state, page) => {
  state.search.page = page
}

export const setProductVariantUpdateData = (state, param) => {
  if (param.index !== undefined && param.index !== '') {
    Vue.set(state.result.lists[param.index], param.field, param.value)
  }
}

export const deleteProductVariantData = (state, param) => {
  state.result.lists.splice(param, 1)
}

export const deleteProductVariantAll = (state) => {
  state.result.lists = {}
}

export const deleteProductVariantSelected = (state, param) => {
  state.result.lists.splice(param.start, param.length)
}



// WEBPACK FOOTER //
// ./src/store/modules/variants/mutations.js